export default __webpack_public_path__ + "static/media/TwoDimensionalImg.72d56c24.jpg";